import React, { useEffect, useState } from 'react';
import { authFetch } from '../utils/api';
import CompanyHeader from '../docs/company_header';
import Drawing from '../drawing';
import DrawTopView from '../draw_top_view';
import DrawScreen from '../DrawScreen';
import DrawWindow from '../DrawWindow';
import Watermark from '../components/Watermark';
import '../entrydoor.css';

const FullQuote = ({ quoteId, showLinePrices = true, documentType = 'Quote' }) => {
  const [quoteRecord,   setQuoteRecord] = useState();
  const [customerInfo, setCustomerInfo] = useState();
  const [quoteData,       setQuoteData] = useState([]);

useEffect(() => {
  if (quoteId) {
    getQuoteRecord(quoteId);
    getQuoteData(quoteId);
  }
}, [quoteId]);

useEffect(() => {
  if (quoteRecord?.fkCustomerId) {
    getCustomerInfo(quoteRecord.fkCustomerId);
  }
}, [quoteRecord]);

  const getQuoteData = async (quoteId) => {
    try {
      const data = await authFetch(`/itemquotes/byquote/${quoteId}`);
      setQuoteData(data);
    } catch (err) {
      console.error('Failed to fetch item quotes:', err);
      if (err.message?.includes('401')) {
        // handleLogout(); // Uncomment if logout logic is needed
      }
    }
  };
  const getQuoteRecord = async (quoteId) => {
    try {
      const data = await authFetch(`/quotes/${quoteId}`);
      setQuoteRecord(data);
    } catch (err) {
      console.error('Failed to fetch quote record:', err);
      if (err.message?.includes('401')) {
        // handleLogout(); // Uncomment if logout logic is needed
      }
    }
  };
  const getCustomerInfo = async (customerId) => {
    try {
      const data = await authFetch(`/customers/${customerId}`);
      setCustomerInfo(data);
    } catch (err) {
      console.error('Failed to fetch customer record:', err);
      if (err.message?.includes('401')) {
        // handleLogout(); // Uncomment if logout logic is needed
      }
    }
  };
  // Calculate grand totals
  const totals = quoteData.reduce(
    (acc, item) => {
      const subtotal = parseFloat(item?.doorData?.calc?.subtotal || 0);
      const discountedSubtotal = parseFloat(item?.doorData?.calc?.discountedSubtotal || subtotal);
      const tax = parseFloat(item?.doorData?.calc?.tax || 0);
      const total = parseFloat(item?.doorData?.calc?.total || 0);

      acc.subtotal += subtotal;
      acc.discountedSubtotal += discountedSubtotal;
      acc.tax += tax;
      acc.total += total;

      return acc;
    },
    { subtotal: 0, discountedSubtotal: 0, tax: 0, total: 0 }
  );

  const customerBoxStyle = {
        border: '1px solid #ccc',
        borderRadius: '15px', // 👈 oval corners
        padding: '1em',
        maxWidth: '300px',
        backgroundColor: '#f9f9f9',
        margin: '1em 0'
};


  return (
    <>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {quoteData.map((item, index) => {
        const calc = item?.doorData?.calc || {};
        const frameData = item?.doorData?.frameData || {};
        const discounts = item?.doorData?.discounts || {};
        const visibleLines = calc.visibleLines || [];
        const doorDataCopy2 = { ...item?.doorData };

        return (
          <div
            key={`page-${item.id}`}
            className="pdf-capture"
            style={{
              maxWidth: '1500px',
              margin: '0 auto',
              textAlign: 'left',
              pageBreakAfter: 'always',
              padding: '20mm',
              boxSizing: 'border-box',
            }}
          >
            <CompanyHeader
              documentType = {documentType}
              quoteData={quoteData[0]?.doorData?.document}
              companyName="Eticom"
            />

            {customerInfo && (
              <div style={customerBoxStyle}>
                <p><strong>Issued To:</strong> {customerInfo?.fullName}</p>
                <p>
                  {customerInfo?.address1}, {customerInfo?.city}, {customerInfo?.postalCode}, {customerInfo?.province}
                </p>
                <p>{customerInfo?.mobilePhone}</p>
                <p>{customerInfo?.email}</p>
              </div>
            )}

            <Watermark show={true}  horizontalOffset={500} />
            <p><strong>{documentType} ID:</strong> {quoteId}</p>

            <div
              style={{
                marginBottom: '2em',
                padding: '1em',
                border: '1px solid #ddd',
                borderRadius: '12px',
                background: '#fdfdfd',
              }}
            >
              {/* Flex container: Left = Drawing, Right = Details */}
              <div style={{ display: 'flex', gap: '2em', alignItems: 'flex-start' }}>
                {/* LEFT SIDE */}
                <div style={{ flex: '0 0 auto' }}>
                {item?.itemType === 'windows/wint/w1' && (
                    <>
                      {
                        
                      }
                      <DrawWindow doorData={doorDataCopy2} useStyle = {false} />
                      <div
                          style={{
                            marginTop: '1em',
                            minHeight: '60px', // Keeps layout consistent
                          }}
                        >
                          <div
                            className="customer-box"
                            style={{
                              border: (item?.doorData?.notes?.LocationTag || item?.doorData?.notes?.notes)
                                ? '1px solid #ccc'
                                : 'none',
                              backgroundColor: (item?.doorData?.notes?.LocationTag || item?.doorData?.notes?.notes)
                                ? '#f9f9f9'
                                : 'transparent',
                              borderRadius: '10px',
                              padding: '0.5em',
                              minHeight: '100%', // fills available height
                            }}
                          >
                            {item?.doorData?.notes?.LocationTag ? (
                              <p><strong>Location:</strong> {item.doorData.notes.LocationTag}</p>
                            ) : (
                              <p style={{ visibility: 'hidden' }}><strong>Location:</strong> Placeholder</p>
                            )}

                            {item?.doorData?.notes?.notes ? (
                              <p><strong>Notes:</strong> {item.doorData.notes.notes}</p>
                            ) : (
                              <p style={{ visibility: 'hidden' }}><strong>Notes:</strong> Placeholder</p>
                            )}
                          </div>
                        </div>

                    </>
                    
                  )}

                  {(item?.itemType === 'entrydooreticom' || item?.itemType === 'patiodoor' || item?.itemType === 'patiodoors') && (
                    <>
                      <Drawing
                        key={`drawing-${item.id}-${index}`}
                        doorData={item?.doorData}
                        selectedDoor={frameData?.selectedDoor}
                        frameColor={frameData?.frameColor}
                        frameWidth={frameData?.frameWidth}
                        frameHeight={frameData?.frameHeight}
                        sideLiteSize={frameData?.sideLiteSize}
                        overallHeight={frameData?.overallHeight}
                        hinges={frameData?.hinges}
                        transom={{
                          transom: { value: item?.doorData?.transomData?.transom },
                          overallHeight: { value: item?.doorData?.transomData?.OverallHeight },
                        }}
                        swing={frameData?.swing}
                        doorLite={{
                          glassDividers: { value: item?.doorData?.doorLite?.glassDividers },
                          glassDividersVertical: { value: item?.doorData?.doorLite?.glassDividersVertical },
                          glassDividersHorizontal: { value: item?.doorData?.doorLite?.glassDividersHorizontal },
                          exteriorFinish: { value: item?.doorData?.doorLite?.exteriorFinish },
                          interiorFinish: { value: item?.doorData?.doorLite?.interiorFinish },
                        }}
                      />
                      <DrawTopView doorData={doorDataCopy2} />
                        <div
                          style={{
                            marginTop: '1em',
                            minHeight: '60px', // Keeps layout consistent
                          }}
                        >
                          <div
                            className="customer-box"
                            style={{
                              border: (item?.doorData?.notes?.LocationTag || item?.doorData?.notes?.notes)
                                ? '1px solid #ccc'
                                : 'none',
                              backgroundColor: (item?.doorData?.notes?.LocationTag || item?.doorData?.notes?.notes)
                                ? '#f9f9f9'
                                : 'transparent',
                              borderRadius: '10px',
                              padding: '0.5em',
                              minHeight: '100%', // fills available height
                            }}
                          >
                            {item?.doorData?.notes?.LocationTag ? (
                              <p><strong>Location:</strong> {item.doorData.notes.LocationTag}</p>
                            ) : (
                              <p style={{ visibility: 'hidden' }}><strong>Location:</strong> Placeholder</p>
                            )}

                            {item?.doorData?.notes?.notes ? (
                              <p><strong>Notes:</strong> {item.doorData.notes.notes}</p>
                            ) : (
                              <p style={{ visibility: 'hidden' }}><strong>Notes:</strong> Placeholder</p>
                            )}
                          </div>
                        </div>


                    </>
                  )}
                  {item?.itemType === 'pleatedscreen' && <DrawScreen doorData={doorDataCopy2} />}
                </div>

                {/* RIGHT SIDE */}
                <div style={{ flex: 1 }}>
                  {visibleLines.map(([key, line], i) =>
                    line?.isVisible ? (
                      <div key={`${item.id}-line-${i}`} style={{ padding: '4px 0' }}>
                        <span dangerouslySetInnerHTML={{ __html: line.html }} />
                        {item?.doorData?.displayPrices !== false &&
                          line?.price?.isVisible &&
                          line?.price?.price != null &&
                          showLinePrices === true && (
                            <span style={{ float: 'right' }}>
                              ${parseFloat(line.price.price).toFixed(2)}
                            </span>
                          )}
                      </div>
                    ) : null
                  )}

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end',
                      marginTop: '1em',
                      paddingTop: '0.5em',
                      borderTop: '1px solid #ccc',
                      width: '100%',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '300px' }}>
                      <span>Quantity:</span>
                      <span style={{ fontWeight: 'bold' }}>{frameData.quantity || 0}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '300px' }}>
                      <span>Subtotal:</span>
                      <span style={{ fontWeight: 'bold' }}>
                        ${parseFloat(calc.subtotal || 0).toFixed(2)}
                      </span>
                    </div>

                    {+discounts?.discount > 0 && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', width: '300px' }}>
                        <span>After Discount ({discounts.discount}%):</span>
                        <span style={{ fontWeight: 'bold' }}>
                          ${parseFloat(calc.discountedSubtotal || 0).toFixed(2)}
                        </span>
                      </div>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '300px' }}>
                      <span>Tax:</span>
                      <span style={{ fontWeight: 'bold' }}>
                        ${parseFloat(calc.tax || 0).toFixed(2)}
                      </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '300px' }}>
                      <span>Total:</span>
                      <span style={{ fontWeight: 'bold' }}>
                        ${parseFloat(calc.total || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
        {/* Grand Totals */}
        {quoteData?.length > 0 && (
      <div
        className="pdf-capture"
        style={{
          maxWidth: '1500px',
          margin: '0 auto',
          textAlign: 'right',
          pageBreakAfter: 'always',
          padding: '20mm',
          boxSizing: 'border-box',
        }}
      >
          <h3 style={{ 
                borderBottom: '2px solid #ccc', 
                paddingBottom: '0.5em',
                fontSize: '1.1em'
              }}>
              Grand Totals
        </h3>
        <div style={{ display: 'inline-block', width: '300px', textAlign: 'left' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
            <span>Subtotal:</span>
            <span style={{ fontWeight: 'bold' }}>${totals.subtotal.toFixed(2)}</span>
          </div>
          {totals.discountedSubtotal < totals.subtotal && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
              <span>After Discount:</span>
              <span style={{ fontWeight: 'bold' }}>${totals.discountedSubtotal.toFixed(2)}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
            <span>Tax:</span>
            <span style={{ fontWeight: 'bold' }}>${totals.tax.toFixed(2)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderTop: '1px solid #ccc', marginTop: '0.5em' }}>
            <span>Total:</span>
            <span style={{ fontWeight: 'bold', fontSize: '16px' }}>${totals.total.toFixed(2)}</span>
          </div>
        </div>
      </div>
    )}
    </div>
  </>

  );


};

// Simple inline styles
const thStyle = {
  borderBottom: '2px solid #ccc',
  textAlign: 'left',
  padding: '8px',
  backgroundColor: '#f0f0f0'
};

const tdStyle = {
  borderBottom: '1px solid #eee',
  textAlign: 'left',
  padding: '8px'
};

export default FullQuote;
